<template>
    <div class="pagination" v-if="total > 1">
        <div class="page prev prev-arrow" @click="goToPage(1)" v-if="page > 1"><span class="fa fa-angle-double-left"></span></div>
        <div class="page prev" @click="goToPage(i)" v-for="i in backPages">{{i}}</div>
        <div class="page active">{{this.page}}</div>
        <div class="page next" @click="goToPage(i)" v-for="i in nextPages">{{i}}</div>
        <div class="page next next-arrow" @click="goToPage(total)" v-if="page < total"><span class="fa fa-angle-double-right"></span></div>
    </div>
</template>

<script>
    export default {
        name: 'Pagination',
        props: {
            total: {
                type: Number,
                default: 0
            },
            page: {
                type: Number,
                default: 1
            },
            pagesFrontAndBack: {
                type: Number,
                default: 2
            }
        },
        computed: {
            nextPages() {
                if(this.total >= this.page + this.pagesFrontAndBack) {
                    return this.createArray(this.page + 1, this.page + this.pagesFrontAndBack);
                }
                else if(this.total > this.page) {
                    return this.createArray(this.page + 1, this.total);
                }

                return [];
            },

            backPages() {
                if(this.page > this.pagesFrontAndBack) {
                    return this.createArray(this.page - this.pagesFrontAndBack, this.page - 1);
                }
                else if(this.page > 1) {
                    return this.createArray(1, this.page - 1);
                }

                return [];
            },
        },
        methods: {
            createArray(i, n) {
                let array = [];
                for(let j = i; j <= n; j++) {
                    array.push(j);
                }

                return array;
            },

            goToPage(i) {
                this.$emit('goToPage', i);
            }
        }
    }
</script>

<style lang="scss" scoped>

    .pagination {
        margin: 10px 0px;
        padding: 15px 15px;

        &.no-plr {
            padding: 15px 0px;
        }

        @media screen and (min-width: 768px) {
            padding: 15px 0px;
        }

        .page {
            padding: 15px;
            width: 10px;
            height: 10px;
            display: flex;
            align-items: center;
            justify-content: center;
            margin-right: 5px;

            &.next, &.prev {
                cursor: pointer;
                border: 2px solid transparent;

                &:hover {
                    background: #EEEDEC;
                }
            }

            &.active {
                border: 2px solid #0F2443;
            }
        }
    }

</style>
